import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { useQuery } from '@tanstack/react-query';
import { getServers } from './apiHelpers';

export const useServers = () => {
  const { id: restaurantId } = useRestaurant();

  return useQuery({
    initialData: [],
    queryFn: () => getServers(restaurantId),
    queryKey: [restaurantId, 'servers'],
    select: (data) => data.sort((a, b) => a.name.localeCompare(b.name)),
    throwOnError: true,
  });
};
